// @flow

import type {
  EventAction,
  EventActionCreator,
  EventHandler,
} from 'redux/middleware/googleTagManager/types';

import {EVENT_ADD_PAYMENT_INFO} from 'redux/middleware/googleTagManager/actionTypes';
import {GTM_EVENT_ADD_PAYMENT_INFO} from 'redux/middleware/googleTagManager/eventNames';
import {PAYMENT_TYPE_ALTERNATIVE} from 'redux/v1/paymentTravel/models';

type Payload = {|
  isFake?: boolean,
  type?: string,
  insurance?: boolean,
  touroperatorVoucher?: string,
|};

type Action = EventAction<Payload>;

type Event = {
  event: string,
  event_action: string,
  payment_type?: string,
  checkout_step: string,
  non_interaction: false,
  touroperator_voucher?: string,
};

export const action: EventActionCreator<Action, Payload> = (payload) => ({
  type: EVENT_ADD_PAYMENT_INFO,
  payload,
});

export const handler: EventHandler<Action, Event> = (action) => {
  const {isFake, type, insurance, touroperatorVoucher} = action.payload;

  return {
    event: GTM_EVENT_ADD_PAYMENT_INFO,
    event_action: touroperatorVoucher
      ? 'organizer_credit_activated'
      : insurance
      ? 'add_payment_type_insurance'
      : 'add_payment_type',
    checkout_step: '3',
    non_interaction: false,
    ...(touroperatorVoucher
      ? {touroperator_voucher: touroperatorVoucher}
      : {payment_type: isFake ? PAYMENT_TYPE_ALTERNATIVE : type}),
  };
};
